<template>
  <div class="generator-wrapper" @click="closeWrapper">
    <div :class="{'share-box': true, closeAnimation}">
      <div class="top-row">
        <div class="title"> Generate Codes </div>
        <div class="close">
          <font-awesome-icon icon="times" class="icon" @click="close"/>
        </div>
      </div>
      <div class="bottom-row">

        <div class="amount-box">
          <div class="label">Amount</div>
          <div class="input-box">
            <input type="number" v-model="amount">
          </div>
        </div>

        <div class="plan-box">
          <div class="label">Plan</div>
          <div class="input-box">
            <select v-model="plan">
              <option value="5fbfde6a6a78880c8a05952a">Silver 2 m.</option>
              <option value="5fbfe5a46a78880c8a05952b">Gold 2 m.</option>
              <option value="5fcccd2060e9db55ac8ebb7b">Silver 12 m.</option>
              <option value="5fcccd2b60e9db55ac8ebb7c">Gold 12 m.</option>
            </select>
          </div>
        </div>

        <div class="expiration-box">
          <div class="label">Expiration</div>
          <div class="input-box">
            <input type="number" v-model="expiration">
          </div>
        </div>
        
        <div class="generate-button" @click="onGenerate">Generate</div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import alert from '@/lib/alert'

export default {
  name: 'GeneratorWrapper',
  data() {
    return {
      copied: false,
      closeAnimation: false,
      amount: 1,
      plan: '5fbfde6a6a78880c8a05952a',
      expiration: 7
    }
  },
  methods: {
    closeWrapper(event) {
      if(event.target == document.querySelector('.generator-wrapper')) {
        this.close();
      }
    },
    close() {
      this.closeAnimation = true;
      setTimeout(() => {
        this.$emit('close');
      }, 300);
    },
    onGenerate() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}generatePromoCodes`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          amount: this.amount,
          planId: this.plan,
          expiration: this.expiration
        }
      }).then(() => {
        this.close();
      }).catch(err => {
        alert.showError(err);
        this.close();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .generator-wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #252629a8;
    z-index: 90;
    display: flex;
    justify-content: center;
    align-items: center;

    .share-box {
      z-index: 100;
      width: 45rem;
      height: auto;
      background-color: whitesmoke;
      border-radius: 0.2rem;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      animation: open 0.5s forwards;

      @media (max-width: 750px) {
        width: 90vw;
        height: auto;
      }

      @keyframes open {
        0% {
          opacity: 0;
          transform: translateY(5rem);
        }
        100% {
          opacity: 1;
          transform: translateY(0rem);
        }
      }
    }

    .closeAnimation {
      animation: close 0.5s forwards;

      @keyframes close {
        0% {
          opacity: 1;
          transform: translateY(0rem);
        }
        100% {
          opacity: 0;
          transform: translateY(-5rem);
        }
      }
    }

    .top-row {
      width: 100%;
      height: 5rem;
      background-color: #11b6a5;
      display: flex;
      flex-direction: row;

      .title {
        flex: auto;
        height: 100%;
        display: flex;
        align-items: center;
        color: white;
        font-size: 1.5rem;
        padding-left: 2rem;
      }

      .close {
        width: 5rem;
        height: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 1.2rem;

        .icon {
          transition: 0.2s;

          &:hover {
            opacity: 0.8;
            cursor: pointer;
          }
        }
      }
    }

    .bottom-row {
      width: 100%;
      height: 6rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media (max-width: 750px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: auto;
      }

      .amount-box {
        width: auto;
        height: 3rem;
        display: flex;
        margin-left: 1.5rem;
        border-radius: 0.2rem;
        overflow: hidden;

        @media (max-width: 750px) {
          margin-top: 1.5rem;
          margin-left: unset;
          height: 4rem;
        }

        .label {
          width: auto;
          height: 100%;
          padding-left: 1rem;
          padding-right: 1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(199, 199, 199, 0.411);
          color: rgb(134, 134, 134);
          font-weight: bold;

          @media (max-width: 750px) {
            width: 8rem;
            padding-left: unset;
            padding-right: unset;
          }
        }

        .input-box {
          width: 3.5rem;
          height: 100%;
          background-color: rgba(199, 199, 199, 0.822);

          @media (max-width: 750px) {
            width: 5rem;
          }

          input {
            width: 100%;
            height: 100%;
            text-align: center;
            border: none;
            background: none;
            outline: none;
            font-size: 1.3rem;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          }
        }
      }

      .plan-box {
        width: auto;
        height: 3rem;
        display: flex;
        margin-left: 1.5rem;
        border-radius: 0.2rem;
        overflow: hidden;

        @media (max-width: 750px) {
          margin-top: 1rem;
          margin-left: unset;
          height: 4rem;
        }

        .label {
          width: auto;
          height: 100%;
          padding-left: 1rem;
          padding-right: 1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(199, 199, 199, 0.411);
          color: rgb(134, 134, 134);
          font-weight: bold;

          @media (max-width: 750px) {
            width: 8rem;
            padding-left: unset;
            padding-right: unset;
          }
        }

        .input-box {
          width: 7rem;
          height: 100%;
          background-color: rgba(199, 199, 199, 0.822);

          @media (max-width: 750px) {
            width: 5rem;
          }

          select {
            width: 100%;
            height: 100%;
            text-align: center;
            border: none;
            background: none;
            outline: none;
            font-size: 1rem;
          }
        }
      }

      .expiration-box {
        width: auto;
        height: 3rem;
        display: flex;
        margin-left: 1.5rem;
        border-radius: 0.2rem;
        overflow: hidden;

        @media (max-width: 750px) {
          margin-top: 1rem;
          margin-left: unset;
          height: 4rem;
        }

        .label {
          width: auto;
          height: 100%;
          padding-left: 1rem;
          padding-right: 1rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(199, 199, 199, 0.411);
          color: rgb(134, 134, 134);
          font-weight: bold;

          @media (max-width: 750px) {
            width: 8rem;
            padding-left: unset;
            padding-right: unset;
          }
        }

        .input-box {
          width: 3.5rem;
          height: 100%;
          background-color: rgba(199, 199, 199, 0.822);

          @media (max-width: 750px) {
            width: 5rem;
          }

          input {
            width: 100%;
            height: 100%;
            text-align: center;
            border: none;
            background: none;
            outline: none;
            font-size: 1.3rem;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }
          }
        }
      }

      .generate-button {
        height: 3rem;
        width: auto;
        background-color: #11b6a5;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 1.2rem;
        border-radius: 0.3rem;
        transition: 0.3s;
        margin-left: auto;
        margin-right: 1.5rem;

        @media (max-width: 750px) {
          margin-top: 1rem;
          height: 4rem;
          width: 13rem;
          margin-left: unset;
          margin-right: unset;
          margin-bottom: 1.5rem;
        }

        &:hover {
          cursor: pointer;
          background-color: #10a899;
        }
      }
    }
  }
  
</style>